import React from "react";
import { AuthConsumer } from "../../../Helpers/auth.provider";

export const Logout = () => (
    <AuthConsumer>
        {({ logout }) => {
            logout();
            return <span>loading</span>;
        }}
    </AuthConsumer>
);